/**
 * Created by shiyonggao on 2019/2/25.
 */

import lodash from "lodash";
import md5 from "js-md5";
const Common = require("../../common/common");
const state = {
    packlist_ajax_status: {
        user_last: false,
        packagelist: false
    },
    user_last_pay_info: null,
    packagelist_info: null,
    packagelist: {
        // 数据列表
        list: {},

        // 套装选择状态
        countrySelectedStatus: null,

        // 国家地区数量
        countrylength: 0,

        // 选择支付类型状态
        payTypeSelectedStatus: {},

        // 用户无支付记录
        user_nopay_log: false,

        // 选择支付渠道状态
        channelSelectedStatus: {},

        // 存储各个节点选择状态
        saveSelectedStatus: {},

        // 存储套餐标签类型状态
        saveTabStatus: {}
    },
    packagelistDone: false // 初始化完成
};

const handle = {
    time: 500,

    /**
     * 计算ajax管理器
     * @param state
     * @returns {boolean}
     */
    updateAjax(state) {
        let status = true;
        for (let key in state.packlist_ajax_status) {
            if (!state.packlist_ajax_status[key]) {
                status = false;
            }
        }
        return status;
    },

    /**
     * 排序处理入口
     * @param state
     */
    payTypeSort(state) {
        let list = lodash.concat([], state.packagelist_info);
        state.packagelist_info = this.countrySort(list);
        console.log("state.packagelist_info=>", state.packagelist_info);
    },

    /**
     * 处理国家下的支付类型排序
     * @param data
     */
    countrySort(data) {
        let temp = {};
        for (let key in data) {
            let str = md5(data[key]["country"]);
            if (!temp[str]) temp[str] = [];
            temp[str].push(data[key]);
        }
        let res = [];
        for (let k in temp) {
            res = lodash.concat(res, this.sortHandle(temp[k]));
        }
        console.log("countrySort=>", res);
        return res;
    },

    /**
     * 处理支每个国家下面的支付类型排序
     * @param data
     */
    sortHandle(data) {
        let sortObj = {
            creditcard: 0,
            "e-wallet": 1,
            banktransfer: 2,
            epin: 3,
            cash: 4,
            prepaid: 5,
            "virtual-currency": 6,
            mobile: 7,
            other: 8
        };

        // 表识已经被删除数据并产生排序考前的支付渠道
        let flag = {};
        let temp = [];
        let len = data.length;
        for (let i = 0; i < len; i++) {
            let pay_type = data[i]["channel_type"];
            let index = sortObj[pay_type];
            if (!flag[pay_type]) {
                temp[index] = data[i];
                flag[pay_type] = true;
                data[i]["del"] = true;
            } else {
                data[i]["del"] = false;
            }
        }

        // 处理考前的支付渠道排序问题
        let sortBeferData = [];
        for (let key in temp) {
            sortBeferData.push(temp[key]);
        }

        // 去掉以排序数据
        let sortAfterData = [];
        for (let k in data) {
            if (data[k]["del"] === false) {
                sortAfterData.push(data[k]);
            }
        }

        console.log("sortBeferData=>", sortBeferData);
        console.log("sortAfterData=>", sortAfterData);
        return lodash.concat(sortBeferData, sortAfterData);
    },

    /**
     * 添加推荐分类
     * @param state
     */
    addRecommendPayType(state) {
        let res = [];
        for (let key in state.packagelist_info) {
            if (state.packagelist_info[key]["best"] === "Y") {
                let temp = lodash.extend({}, state.packagelist_info[key]);
                temp["channel_type"] = "recommend";
                res.push(temp);
            }
        }
        state.packagelist_info = lodash.concat(res, state.packagelist_info);
    },

    /**
     * 判断套餐信息
     * @param data
     * @returns {*}
     */
    isOnlyPack(data) {
        let res = {};
        if (lodash.size(data.props) > 0 && lodash.size(data.package) > 0) {
            res = {
                tabValue: {
                    pack: "pack",
                    prop: "prop"
                },
                tab: "pack"
            };
        } else {
            if (lodash.size(data.props) > 0) {
                res = {
                    tabValue: {
                        prop: "prop"
                    },
                    tab: "prop"
                };
            }
            if (lodash.size(data.package) > 0) {
                res = {
                    tabValue: {
                        pack: "pack"
                    },
                    tab: "pack"
                };
            }
        }
        return res;
    },

    /**
     * 设置选择国家
     * @param state
     * @param resCountry
     */
    setSelectedCountry(state, resCountry) {
        state.packagelist.countrySelectedStatus = null;
        let len = 0;
        for (let key in resCountry) {
            // 设置默认用户选择国家或者地区
            if (len === 0) {
                state.packagelist.countrySelectedStatus = key;
            }

            // 用户无支付记录不处理
            if (lodash.isArray(state.user_last_pay_info)) {
                state.packagelist.user_nopay_log = true;
                len++;
                continue;
            }

            // 用户有支付记录并设置用户上次支付的国家信息
            if (md5(state.user_last_pay_info.last_pay_country) === key) {
                state.packagelist.countrySelectedStatus = key;
            }
            len++;
        }

        state.packagelist.countrylength = len;
        console.log(
            "user_nopay_log countrylength",
            state.packagelist.user_nopay_log,
            state.packagelist.countrylength
        );
    },

    /**
     * 设置选择支付类型
     * @param state
     * @param resCountry
     */
    setSelectedPayType(state, resCountry) {
        for (let key in resCountry) {
            let len = 0;
            for (let k in resCountry[key]) {
                // 设置默认用户选择
                if (len === 0) {
                    state.packagelist.payTypeSelectedStatus[key] = k;
                }

                // 用户无支付记录不处理
                if (lodash.isArray(state.user_last_pay_info)) {
                    len++;
                    continue;
                }

                // 用户有支付记录并设置用户上次支付的国家信息
                if (
                    md5(
                        state.user_last_pay_info.last_pay_country +
                            state.user_last_pay_info.last_pay_channel_type
                    ) === k
                ) {
                    state.packagelist.payTypeSelectedStatus[key] = k;
                }
                len++;
            }
        }
        console.log(
            "packagelist.payTypeSelectedStatus=>",
            state.packagelist.payTypeSelectedStatus
        );
    },

    /**
     * 选择支付渠道
     * @param state
     * @param resCountry
     */
    setSelectedChannel(state, resCountry) {
        for (let key in resCountry) {
            for (let k in resCountry[key]) {
                let len = 0;
                for (let j in resCountry[key][k]) {
                    // if(len === 0) console.log(k);
                    // console.log(k, len, resCountry[key][k][j]);

                    // 设置默认用户选择
                    if (len === 0) {
                        state.packagelist.channelSelectedStatus[k] = j;
                    }

                    // 用户无支付记录不处理
                    if (lodash.isArray(state.user_last_pay_info)) {
                        len++;
                        console.log("continue", len);
                        continue;
                    }

                    // console.log(j,md5(resCountry[key][k][j]['type_md5_key']+ state.user_last_pay_info.last_pay_channel+state.user_last_pay_info.last_pay_channel_sub))
                    // 用户有支付记录并设置用户上次支付的国家信息
                    if (
                        md5(
                            resCountry[key][k][j]["type_md5_key"] +
                                state.user_last_pay_info.last_pay_channel +
                                state.user_last_pay_info.last_pay_channel_sub
                        ) === j
                    ) {
                        state.packagelist.channelSelectedStatus[k] = j;
                    }
                    len++;
                }
            }
        }
    },

    packageListHandles(data, type, rootState) {
        let base = rootState.$lang["select_pay_ohter"];
        let tag = "props_tag";
        let smsTag = "sms_operator";
        let tagTab = {};
        let operatorTabStatus = {};
        let operatorTab = {};
        let channelMap = {};
        let activeTagKey = null;
        let activeOperatorKey = null;
        let content = {};
        for (let key in data) {
            // 套餐标签为空
            if (!data[key][tag]) {
                data[key][tag] = base;
                data[key]["props_tag_code"] = "other";
            }

            // 运营商为空
            if (!data[key][smsTag]) {
                data[key][smsTag] = base;
                data[key]["sms_operator_code"] = "other";
            }

            // 设置key
            let tagMD5Str = md5(data[key][tag]);
            let smsTagMD5Str = md5(data[key][tag] + data[key][smsTag]);

            // 设置tag类型
            if (!tagTab[tagMD5Str]) tagTab[tagMD5Str] = data[key][tag];

            if (!operatorTabStatus[tagMD5Str]) {
                operatorTabStatus[tagMD5Str] = smsTagMD5Str;
            }

            // 第一次创建某个对象
            if (!content[tagMD5Str]) {
                content[tagMD5Str] = {};
                content[tagMD5Str][smsTagMD5Str] = [];

                operatorTab[tagMD5Str] = {};
                operatorTab[tagMD5Str][smsTagMD5Str] = {};

                channelMap[tagMD5Str] = {};
                channelMap[tagMD5Str][smsTagMD5Str] = null;
            } else {
                if (!content[tagMD5Str][smsTagMD5Str]) {
                    content[tagMD5Str][smsTagMD5Str] = [];
                    operatorTab[tagMD5Str][smsTagMD5Str] = {};
                    channelMap[tagMD5Str][smsTagMD5Str] = null;
                }
            }
            data[key]["tag_md5_key"] = tagMD5Str;
            data[key]["sms_tag_md5_key"] = smsTagMD5Str;
            content[tagMD5Str][smsTagMD5Str].push(data[key]);
            operatorTab[tagMD5Str][smsTagMD5Str] = data[key][smsTag];

            // 初始化选中状态
            if (content[tagMD5Str][smsTagMD5Str].length === 1) {
                channelMap[tagMD5Str][smsTagMD5Str] = 0;
            }

            // 选择第一个元素
            if (key === "0") {
                activeTagKey = tagMD5Str;
                activeOperatorKey = smsTagMD5Str;
            }
        }
        return {
            type: type,
            tagTab: tagTab,
            operatorTab: operatorTab,
            channelMap: channelMap,
            activeTagKey: activeTagKey,
            activeOperatorKey: activeOperatorKey,
            content: content,
            operatorTabStatus: operatorTabStatus
        };
    },

    /**
     * 初始化package数据
     * @param state
     * @param rootState
     */
    initPackageData(state, rootState) {
        let res = {
            packagelist: {},
            saveSelectedStatus: {},
            saveTabStatus: {}
        };
        console.log(state.user_last_pay_info);
        console.log(state.packagelist_info);

        // 按国家地区，按支付类型，按渠道分类
        for (let key in state.packagelist_info) {
            // 生成国家地区key=> md5(country)
            let countryMd5Str = md5(state.packagelist_info[key]["country"]);

            // 生产推荐分类
            let bestMd5str = md5(
                state.packagelist_info[key]["country"] + "_best"
            );

            // 生成支付类型key=> md5(country + channel_type)
            // console.log('typeMd5Str=>', state.packagelist_info[key]['country'] , state.packagelist_info[key]['channel_type'] );
            let typeMd5Str = md5(
                state.packagelist_info[key]["country"] +
                    state.packagelist_info[key]["channel_type"]
            );

            // 生成支付渠道类型key=> md5(typeMd5Str + channel_code + channel_sub_code)
            // console.log('typeMd5Str',typeMd5Str, state.packagelist_info[key]['channel_code'], state.packagelist_info[key]['channel_sub_code'])
            let channelMd5Str = md5(
                typeMd5Str +
                    state.packagelist_info[key]["channel_code"] +
                    state.packagelist_info[key]["channel_sub_code"]
            );

            /** **国家地区，支付类型，支付渠道逻辑分类****/
            if (!res.packagelist[countryMd5Str]) {
                // 按国家地区分类
                res.packagelist[countryMd5Str] = {};
                res.packagelist[countryMd5Str][typeMd5Str] = {};
                res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str] = {};

                // 创建存储空间
                res.saveSelectedStatus[countryMd5Str] = {};
                res.saveSelectedStatus[countryMd5Str][typeMd5Str] = {};
                res.saveSelectedStatus[countryMd5Str][typeMd5Str][
                    channelMd5Str
                ] = {};

                // 创建套餐标签空间
                res.saveTabStatus[countryMd5Str] = {};
                res.saveTabStatus[countryMd5Str][typeMd5Str] = {};
                res.saveTabStatus[countryMd5Str][typeMd5Str][
                    channelMd5Str
                ] = {};

                state.packagelist_info[key]["country_md5_key"] = countryMd5Str;
                state.packagelist_info[key]["type_md5_key"] = typeMd5Str;
                state.packagelist_info[key]["channed_md5_key"] = channelMd5Str;
                res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str] =
                    state.packagelist_info[key];
            } else {
                if (!res.packagelist[countryMd5Str][typeMd5Str]) {
                    // 按国家地区分类
                    res.packagelist[countryMd5Str][typeMd5Str] = {};
                    res.packagelist[countryMd5Str][typeMd5Str][
                        channelMd5Str
                    ] = {};

                    // 创建存储空间
                    res.saveSelectedStatus[countryMd5Str][typeMd5Str] = {};
                    res.saveSelectedStatus[countryMd5Str][typeMd5Str][
                        channelMd5Str
                    ] = {};

                    // 创建套餐标签空间
                    res.saveTabStatus[countryMd5Str][typeMd5Str] = {};
                    res.saveTabStatus[countryMd5Str][typeMd5Str][
                        channelMd5Str
                    ] = {};
                } else {
                    if (
                        !res.packagelist[countryMd5Str][typeMd5Str][
                            channelMd5Str
                        ]
                    ) {
                        // 按国家地区分类
                        res.packagelist[countryMd5Str][typeMd5Str][
                            channelMd5Str
                        ] = {};

                        // 创建存储空间
                        res.saveSelectedStatus[countryMd5Str][typeMd5Str][
                            channelMd5Str
                        ] = {};

                        // 创建套餐标签空间
                        res.saveTabStatus[countryMd5Str][typeMd5Str][
                            channelMd5Str
                        ] = {};
                    }
                }

                state.packagelist_info[key]["country_md5_key"] = countryMd5Str;
                state.packagelist_info[key]["type_md5_key"] = typeMd5Str;
                state.packagelist_info[key]["channed_md5_key"] = channelMd5Str;
                res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str] =
                    state.packagelist_info[key];
            }

            /** **道具和套餐逻辑分类****/
            let package_list =
                res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str][
                    "package_list"
                ];
            res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str][
                "init_data"
            ] = {};

            // 套餐和道具信息为空
            // if (package_list.length === 0) {
            //     res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str]['init_data']['packs'] = [];
            //     res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str]['init_data']['props'] = [];
            // }

            // 存储tab状态
            res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str][
                "tab"
            ] = this.isOnlyPack(package_list);

            // 无道具套餐配置
            // if(res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str]['tab']['tab'] === 'pack'){
            //     res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str]['init_data']['props'] = [];
            // }

            // 无套餐配置
            // if(res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str]['tab']['tab'] === 'prop'){
            //     res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str]['init_data']['package'] = [];
            // }

            // 有支付套餐配置
            // if (package_list['package'] && package_list['package'].length > 0){
            res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str][
                "init_data"
            ]["package"] = this.packageListHandles(
                package_list["package"],
                "package",
                rootState
            );
            // }

            // 有支付道具配置
            // if (package_list['props'] && package_list['props'].length > 0) {
            res.packagelist[countryMd5Str][typeMd5Str][channelMd5Str][
                "init_data"
            ]["props"] = this.packageListHandles(
                package_list["props"],
                "props",
                rootState
            );
            // }
        }

        // 设置默认国家或地区并获取国家或者地区列表
        this.setSelectedCountry(state, res.packagelist);
        this.setSelectedPayType(state, res.packagelist);
        this.setSelectedChannel(state, res.packagelist);

        state.packagelist.list = res.packagelist;
        console.log("state.packagelist=>", state.packagelist);
    }
};

const actions = {
    /**
     * 获取套餐配置列表
     * @param state
     * @param commit
     * @param rootState
     * @constructor
     */
    GET_PACKAGE_LIST_INFO({ state, commit, rootState }) {
        const versionInfo = rootState.$appConfig.getVersionInfo();
        let url =
            versionInfo.api.app_base_url + versionInfo.api.app_package_info;
        let params = {
            merchant_shop_code: rootState.$appConfig.PARAMS.merchant_shop_code,
            platform: rootState.$appConfig.PARAMS.platform,
            user_id: rootState.$appConfig.PARAMS.user_id,
            server_id: rootState.$appConfig.PARAMS.server_id
        };
        const urlParams = Common.parseURL(window.location.href).params;

        rootState.$common.ajax({
            url: url,
            data: params,
            success(res) {
                if (res.code === 200) {
                    console.log(res.result.data, urlParams, 123);
                    // 无配置渠道
                    if (res.result.data.length === 0) {
                        console.log("无配置渠道");
                        commit("SET_NO_CHANNEL_DATA", true, { root: true });
                        commit("SET_AJAX_STATUS", ["packageList", true], {
                            root: true
                        });
                        return false;
                    }
                    const data = res.result.data.filter(item => {
                        if (
                            urlParams.windows_store &&
                            Number(urlParams.windows_store)
                        ) {
                            return item.channel_code === "windows";
                        } else {
                            return item.channel_code !== "windows";
                        }
                    });
                    console.log("AJAX_PACKAGE_LIST=>", data);
                    commit("SET_PACKAGE_LIST", data);
                    commit("SET_AJAX_STATUS", [
                        "packagelist",
                        true,
                        rootState,
                        commit
                    ]);
                }
            },
            error(res) {
                console.log("AJAX_PACKAGE_LIST_FAIL=>", res);
                res = JSON.parse(res.responseText);
                if (res.code === 400) {
                    rootState.$popStatus = {
                        show: true,
                        title: rootState.$lang.tips_text,
                        desc: JSON.parse(res.message)["error_msg"],
                        btn: {
                            yes: true,
                            no: false
                        },
                        callback($state, popDeflaut) {
                            $state.$popStatus = popDeflaut;
                        }
                    };
                }
            }
        });
    },

    /**
     * 获取用户最后使用支付渠道
     * @param state
     * @param commit
     * @param rootState
     * @constructor
     */
    GET_USER_LAST_PAY_INFO({ state, commit, rootState }) {
        const versionInfo = rootState.$appConfig.getVersionInfo();
        let url = versionInfo.api.app_base_url + versionInfo.api.app_user_last;

        let params = {
            merchant_shop_code: rootState.$appConfig.PARAMS.merchant_shop_code,
            user_id: rootState.$appConfig.PARAMS.user_id
        };

        rootState.$common.ajax({
            url: url,
            data: params,
            success(res) {
                // res = {
                //     "code": 200,
                //     "result": {
                //         "last_pay_country": "US",
                //         "last_pay_channel": "adyen",
                //         "last_pay_channel_sub": "",
                //         "last_pay_channel_type": "creditcard"
                //     },
                //     "message": "success"
                // };

                // res['result'] = [];

                console.log("AJAX_USER_LAST_PAY_INFO=>", res);
                if (res.code === 200) {
                    commit("SET_USER_LAST_PAY_INFO", res.result);
                    commit("SET_AJAX_STATUS", [
                        "user_last",
                        true,
                        rootState,
                        commit
                    ]);
                }
            },
            error(res) {
                console.log("AJAX_USER_LAST_PAY_FAIL=>", res);
            }
        });
    },

    /**
     * 用户重新国家
     * @param state
     * @param commit
     * @param rootState
     * @param args
     * @constructor
     */
    CLICK_USER_SELECTED_COUNTRY({ state, commit, rootState }, args) {
        if (args.key === state.packagelist.countrySelectedStatus) return;
        commit("PACKAGE_LOADING", true, { root: true });
        commit("CHANGE_USER_SELECTED_COUNTRY", args);
        setTimeout(function() {
            commit("PACKAGE_LOADING", false, { root: true });
        }, handle.time);
    },

    /**
     * 用户选择支付类型
     * @param state
     * @param commit
     * @param rootState
     * @param args
     * @constructor
     */
    CLICK_USER_SELECTED_TYPE({ state, commit, rootState }, args) {
        if (
            args.key ===
            state.packagelist.payTypeSelectedStatus[args.item.country_md5_key]
        ) {
            return;
        }
        commit("PACKAGE_LOADING", true, { root: true });
        commit("CHANGE_USER_SELECTED_TYPE", args);
        setTimeout(function() {
            commit("PACKAGE_LOADING", false, { root: true });
        }, handle.time);
    },

    /**
     * 用户选择支付渠道
     * @param state
     * @param commit
     * @param rootState
     * @param args
     * @constructor
     */
    CLICK_USER_SELECTED_CHANNEL({ state, commit, rootState }, args) {
        if (
            args.key ===
            state.packagelist.channelSelectedStatus[args.item.type_md5_key]
        ) {
            return;
        }
        commit("PACKAGE_LOADING", true, { root: true });
        commit("CHANGE_USER_SELECTED_CHANNEL", args);
        setTimeout(function() {
            commit("PACKAGE_LOADING", false, { root: true });
        }, handle.time);
    },

    /**
     * 用户选择支付套餐
     * @param state
     * @param commit
     * @param rootState
     * @param arge
     * @constructor
     */
    CLICK_USER_SELECTED_CHANNEL_PACKAGE({ state, commit, rootState }, arge) {
        commit("CHANGE_USER_SELECTED_CHANNEL_PACKAGE", arge);
    },

    /**
     * 用户选择支付套餐详情
     * @param state
     * @param commit
     * @param rootState
     * @param args
     * @constructor
     */
    CLICK_USER_SELECTED_CHANNEL_PACKAGE_INFO(
        { state, commit, rootState },
        args
    ) {
        commit("CHANGE_USER_SELECTED_CHANNEL_PACKAGE_INFO", args);
    },

    /**
     * 用户切换道具与套餐
     * @param state
     * @param commit
     * @param rootState
     * @param key
     * @constructor
     */
    CLICK_USER_PACKAGES_TAB({ state, commit, rootState }, key) {
        commit("CHANGE_USER_PACKAGES_TAB", key);
    },

    /**
     * 用户选择渠道下的套餐运营商
     * @param state
     * @param commit
     * @param rootState
     * @param args
     * @constructor
     */
    CLICK_USER_SELECTED_CHANNEL_PACKAGE_OPERATOR(
        { state, commit, rootState },
        args
    ) {
        commit("CHANGE_USER_SELECTED_CHANNEL_PACKAGE_OPERATOR", args);
    },

    /**
     * 用户选择渠道下的标签分类
     * @param state
     * @param commit
     * @param rootState
     * @param args
     * @constructor
     */
    CLICK_USER_SELECTED_CHANNEL_PACKAGE_TAG(
        { state, commit, rootState },
        args
    ) {
        commit("CHANGE_USER_SELECTED_CHANNEL_PACKAGE_TAG", args);
    }
};

const getters = {
    /**
     * 获取支付类型数据
     * @param state
     * @param getters
     * @constructor
     */
    GET_PAY_TYPE_DATA(state, getters) {
        let res = {};
        let list =
            state.packagelist.list[state.packagelist.countrySelectedStatus];
        for (let key in list) {
            for (let k in list[key]) {
                if (!res[list[key][k]["type_md5_key"]]) {
                    res[list[key][k]["type_md5_key"]] = list[key][k];
                }
            }
        }
        return res;
    },

    /**
     * 获取当前选择国家或者地区数据
     * @param state
     * @param getters
     * @returns {*}
     * @constructor
     */
    GET_SELECTED_COUNTRY_DATA(state, getters) {
        return getters.GET_COUNTRY_DATA[
            state.packagelist.countrySelectedStatus
        ];
    },

    /**
     * 获取国家或者地区列表数据
     * @param state
     * @param getters
     * @constructor
     */
    GET_COUNTRY_DATA(state, getters) {
        let temp = {};
        for (let g in state.packagelist_info) {
            if (state.packagelist_info[g]["channel_type"] !== "recommend") {
                let countryMd5Str = md5(state.packagelist_info[g]["country"]);
                if (!temp[countryMd5Str]) {
                    temp[countryMd5Str] = true;
                }
            }
        }

        for (let h in temp) {
            for (let key in state.packagelist.list) {
                for (let k in state.packagelist.list[key]) {
                    for (let j in state.packagelist.list[key][k]) {
                        // console.log('aaaaa', state.packagelist.list[key][k][j]['country_md5_key'], h);
                        if (
                            h ===
                            state.packagelist.list[key][k][j]["country_md5_key"]
                        ) {
                            temp[h] = state.packagelist.list[key][k][j];
                            break;
                        }
                    }
                }
            }
        }

        return temp;
    },

    /**
     * 获取当前国家，当前支付类型下的渠道列表
     * @param state
     * @param getters
     * @constructor
     */
    GET_PAY_CHANNEL_DATA(state, getters) {
        let payType =
            state.packagelist.payTypeSelectedStatus[
                state.packagelist.countrySelectedStatus
            ];
        return state.packagelist.list[state.packagelist.countrySelectedStatus][
            payType
        ];
    },

    /**
     * 获取当前国家，支付类型，支付渠道下的道具
     * @param state
     * @param getters
     * @constructor
     */
    GET_PACKAGE_PROPS_DATA(state, getters) {
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        // console.log(actChannel, actChannel, actCountry)
        return state.packagelist.list[actCountry][actPayType][actChannel][
            "init_data"
        ].props;
    },

    /**
     * 获取当前国家，支付类型，支付渠道下的套餐详情
     * @param state
     * @param getters
     * @constructor
     */
    GET_PACKAGE_PACKS_DATA(state, getters) {
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        // console.log(actChannel, actChannel, actCountry)
        return state.packagelist.list[actCountry][actPayType][actChannel][
            "init_data"
        ].package;
    },

    /**
     * 获取当前国家，支付类型，支付渠道下的套餐
     * @param state
     * @param getters
     * @constructor
     */
    GET_PACKAGE_PACKS_DATA_CONTENT(state, getters) {
        let data = getters.GET_PACKAGE_PACKS_DATA;
        return data.content[data.activeTagKey][
            data.operatorTabStatus[data.activeTagKey]
        ];
    },

    /**
     * 获取当前国家，支付类型，支付渠道下的套餐
     * @param state
     * @param getters
     * @constructor
     */
    GET_PACKAGE_PROPS_DATA_CONTENT(state, getters) {
        let data = getters.GET_PACKAGE_PROPS_DATA;
        return data.content[data.activeTagKey][
            data.operatorTabStatus[data.activeTagKey]
        ];
    },

    /**
     * 获取当前国家，支付类型，支付渠道下的套餐或者道具
     * @param state
     * @param getters
     * @constructor
     */
    GET_PACKAGE_TAB_DATA(state, getters) {
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        return state.packagelist.list[actCountry][actPayType][actChannel][
            "tab"
        ];
    },

    /**
     * 获取选择的渠道
     * @param state
     * @param getters
     * @constructor
     */
    GET_ACTIVE_CHANNEL_DATA(state, getters) {
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        return state.packagelist.list[actCountry][actPayType][actChannel];
    }
};

const mutations = {
    /**
     * 用户最后使用的渠道和应用套餐加载完全处理state.packagelist数据
     * @param state
     * @param args
     * @constructor
     */
    SET_AJAX_STATUS(state, args) {
        state.packlist_ajax_status[args[0]] = args[1];
        let status = handle.updateAjax(state);
        if (status) {
            handle.payTypeSort(state); // 支付类型排序
            handle.addRecommendPayType(state); // 设置推荐分类
            handle.initPackageData(state, args[2]); // 初始化state.packagelist数据模型
            state.packagelistDone = true;
            args[3]("SET_AJAX_STATUS", ["packageList", true], { root: true });
        }
    },

    /**
     * 存储用户最后一次支付渠道信息
     * @param state
     * @param data
     * @constructor
     */
    SET_USER_LAST_PAY_INFO(state, data) {
        state.user_last_pay_info = data;
    },

    /**
     * 存储套餐列表
     * @param state
     * @param data
     * @constructor
     */
    SET_PACKAGE_LIST(state, data) {
        state.packagelist_info = data;
    },

    /**
     * 用户重新国家
     * @param state
     * @param args
     * @constructor
     */
    CHANGE_USER_SELECTED_COUNTRY(state, args) {
        console.log("用户重新国家处理", args);
        if (args.key === state.packagelist.countrySelectedStatus) return;
        state.packagelist.countrySelectedStatus = args.key;
    },

    /**
     * 用户选择支付类型
     * @param state
     * @param args
     * @constructor
     */
    CHANGE_USER_SELECTED_TYPE(state, args) {
        console.log("用户选择支付类型", args);
        if (
            args.key ===
            state.packagelist.payTypeSelectedStatus[args.item.country_md5_key]
        ) {
            return;
        }
        state.packagelist.payTypeSelectedStatus[args.item.country_md5_key] =
            args.key;

        // 强制刷新state属性，防止state修改属性之后不生效
        state.packagelist.payTypeSelectedStatus = lodash["extend"](
            {},
            state.packagelist.payTypeSelectedStatus
        );
    },

    /**
     * 用户选择支付渠道
     * @param state
     * @param args
     * @constructor
     */
    CHANGE_USER_SELECTED_CHANNEL(state, args) {
        console.log("用户选择支付渠道", args);
        if (
            args.key ===
            state.packagelist.channelSelectedStatus[args.item.type_md5_key]
        ) {
            return;
        }
        state.packagelist.channelSelectedStatus[args.item.type_md5_key] =
            args.key;

        // 强制刷新state属性，防止state修改属性之后不生效
        state.packagelist.channelSelectedStatus = lodash["extend"](
            {},
            state.packagelist.channelSelectedStatus
        );
    },

    /**
     * 用户选择支付渠道支付套餐
     * @param state
     * @param args
     * @constructor
     */
    CHANGE_USER_SELECTED_CHANNEL_PACKAGE(state, args) {
        console.log("用户选择支付渠道支付套餐", args);
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        if (
            args.key ===
            state.packagelist.list[actCountry][actPayType][actChannel][
                "init_data"
            ][args.type].selectedTabValue
        ) {
            return;
        }
        state.packagelist.list[actCountry][actPayType][actChannel]["init_data"][
            args.type
        ].selectedTabValue = args.key;

        // 强制刷新state属性，防止state修改属性之后不生效
        state.packagelist.list = lodash["extend"]({}, state.packagelist.list);
        console.log(
            state.packagelist.list[actCountry][actPayType][actChannel][
                "init_data"
            ][args.type]
        );
    },

    /**
     * 用户选择支付套餐详情
     * @param state
     * @param args
     * @constructor
     */
    CHANGE_USER_SELECTED_CHANNEL_PACKAGE_INFO(state, args) {
        console.log("用户选择支付套餐详情", args);
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        let list =
            state.packagelist.list[actCountry][actPayType][actChannel][
                "init_data"
            ][args.type];
        if (
            args.index ===
            list.channelMap[args.item.tag_md5_key][args.item.sms_tag_md5_key]
        ) {
            return;
        }
        state.packagelist.list[actCountry][actPayType][actChannel]["init_data"][
            args.type
        ].channelMap[args.item.tag_md5_key][args.item.sms_tag_md5_key] =
            args.index;

        // 强制刷新state属性，防止state修改属性之后不生效
        state.packagelist.list = lodash["extend"]({}, state.packagelist.list);
    },

    /**
     * 用户切换道具与套餐
     * @param state
     * @param key
     * @constructor
     */
    CHANGE_USER_PACKAGES_TAB(state, key) {
        console.log("用户切换道具与套餐", key);
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        let list =
            state.packagelist.list[actCountry][actPayType][actChannel]["tab"];
        if (key === list.tab) return;
        state.packagelist.list[actCountry][actPayType][actChannel][
            "tab"
        ].tab = key;

        // 强制刷新state属性，防止state修改属性之后不生效
        state.packagelist.list = lodash["extend"]({}, state.packagelist.list);
    },

    /**
     * 更改用户选择渠道下的套餐标签分类
     * @param state
     * @param args
     * @constructor
     */
    CHANGE_USER_SELECTED_CHANNEL_PACKAGE_TAG(state, args) {
        console.log("更改用户选择渠道下的套餐标签分类", args);
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        if (
            args.key ===
            state.packagelist.list[actCountry][actPayType][actChannel][
                "init_data"
            ][args.type].activeTagKey
        ) {
            return;
        }
        state.packagelist.list[actCountry][actPayType][actChannel]["init_data"][
            args.type
        ].activeTagKey = args.key;

        // 强制刷新state属性，防止state修改属性之后不生效
        state.packagelist.list = lodash["extend"]({}, state.packagelist.list);
    },

    /**
     * 更改用户选择渠道下的套餐运营商
     * @param state
     * @param args
     * @constructor
     */
    CHANGE_USER_SELECTED_CHANNEL_PACKAGE_OPERATOR(state, args) {
        console.log("用户选择支付渠道下的套餐运营商", args);
        let actCountry = state.packagelist.countrySelectedStatus;
        let actPayType = state.packagelist.payTypeSelectedStatus[actCountry];
        let actChannel = state.packagelist.channelSelectedStatus[actPayType];
        let list =
            state.packagelist.list[actCountry][actPayType][actChannel][
                "init_data"
            ][args.type];
        if (args.key === list.operatorTabStatus[list.activeTagKey]) return;
        list.operatorTabStatus[list.activeTagKey] = args.key;

        state.packagelist.list[actCountry][actPayType][actChannel]["init_data"][
            args.type
        ] = list;

        // 强制刷新state属性，防止state修改属性之后不生效
        state.packagelist.list = lodash["extend"]({}, state.packagelist.list);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/get_package_info.js